import { render, staticRenderFns } from "./BlockSvg.vue?vue&type=template&id=61c807bb&scoped=true&"
import script from "./BlockSvg.vue?vue&type=script&lang=js&"
export * from "./BlockSvg.vue?vue&type=script&lang=js&"
import style0 from "./BlockSvg.vue?vue&type=style&index=0&id=61c807bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c807bb",
  null
  
)

export default component.exports